import { ProductDto } from '@eurogast/hub-client-typescript';

export default interface ProductService {
  getProductBySkuBatch(
    skus: string[],
    showInactive?: boolean
  ): Promise<ProductDto[]>;
}

export const CONVI_KEY = 'CONVI';
